﻿import React from 'react';
import PropTypes from 'prop-types';

export default class RadioButtonList extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.renderRadioButton = this.renderRadioButton.bind(this);
        this.getRadioButtonClasses = this.getRadioButtonClasses.bind(this);
    }

    onChange(val) {
        this.props.onChange(val.target.value);
    }

    getRadioButtonClasses() {
        let defaultClasses = "custom-control custom-radio";
        if (this.props.isInline) {
            defaultClasses += " custom-control-inline";
        }

        return defaultClasses;
    }

    renderRadioButton(option) {
        return (
            <div className={this.getRadioButtonClasses()}>
                <input
                    role="radio"
                    aria-checked={option.value === this.props.value}
                    type="radio"
                    id={this.props.name + "-" + option.id}
                    name={this.props.name}
                    className="custom-control-input"
                    checked={option.value === this.props.value}
                    onChange={this.onChange}
                    value={option.value}
                    disabled={this.props.disabled}
                />
                <label className="custom-control-label" htmlFor={this.props.name + "-" + option.id}>{option.text}</label>
            </div>
        );
    }

    render() {
        let successState = null;
        if (this.props.isValid !== null && this.props.isValid !== undefined) {
            if (this.props.isValid) {
                successState = "is-valid";
            }
            else {
                successState = "is-invalid";
            }
        }
        let radioButtons = [];
        let i = 0;
        while (i < this.props.options.length) {
            radioButtons.push(
                <div key={"option" + i}>
                    {
                        this.renderRadioButton(this.props.options[i])
                    }
                    {
                        i + 1 < this.props.options.length &&
                        this.renderRadioButton(this.props.options[++i])
                    }
                </div>
            );
            i++;
        }
        return (
            <div className={this.props.className ? "radio-list " + this.props.className : "radio-list"}>
                <label htmlFor={this.props.id}>
                    {this.props.label}
                </label>
                <div className={successState ? "radio-buttons " + successState : "radio-buttons"}>
                    {radioButtons}
                </div>                
                {this.props.invalidFeedback && (
                    <div className="invalid-feedback text">
                        <span className='invalid-icon'/>
                        {this.props.invalidFeedback}
                    </div>
                )}
            </div>
        );
    }
}

RadioButtonList.propTypes = {
    disabled: PropTypes.bool,
    invalidFeedback: PropTypes.string,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        text: PropTypes.string,
        value: PropTypes.string
    })).isRequired,
    value: PropTypes.string.isRequired,
    isInline: PropTypes.bool
};


RadioButtonList.defaultProps = {
    isInline: true,
    disabled: false,
    isValid: true
};